import { WidgetExtended } from '@/types/dashboard'
import { computed, type Ref } from 'vue'
import { warningSoundList, errorSoundList, allSoundList, getSoundObject } from '@/composables/globalData/useEntitiesData'
import i18n from '@/i18n'
import { ISoundItem } from '@/types/sound'
import {
    limitThresholdValue,
    warningThresholdValue,
    NotificationSetupParams,
} from '@/composables/useSoundsThresholdNotification'
import { setupSoundQueue } from '@/composables/useSoundsStoreData'

export function useQueuesThresholdNotifications (widgetRef: Ref<WidgetExtended>) {
    const maximumWarningCallersValueFromSettings = computed(() =>
        Number(widgetRef.value?.WidgetLayout?.maximumWarningCallersValue || 0))

    const maximumLimitCallersValueFromSettings = computed(() =>
        Number(widgetRef.value?.WidgetLayout?.maximumLimitCallersValue || 0))

    const maximumWarningWaitTimeValueFromSettings = computed(() =>
        widgetRef.value?.WidgetLayout?.maximumWarningMaxRingTimeValue || 0)

    const maximumLimitWaitTimeValueFromSettings = computed(() =>
        widgetRef.value?.WidgetLayout?.maximumLimitMaxRingTimeValue || 0)

    const maximumLimitCallersSound = computed(() => {
        if (widgetRef.value?.WidgetLayout?.maximumLimitCallersSound) {
            return getSoundObject(errorSoundList.value, widgetRef.value.WidgetLayout.maximumLimitCallersSound)?.Rec_Path || ''
        }
        return ''
    })

    const maximumWarningCallersSound = computed(() => {
        if (widgetRef.value?.WidgetLayout?.maximumWarningCallersSound) {
            return getSoundObject(warningSoundList.value, widgetRef.value.WidgetLayout.maximumWarningCallersSound)?.Rec_Path || ''
        }
        return ''
    })

    const maximumWarningMaxRingTimeSound = computed(() => {
        if (widgetRef.value?.WidgetLayout?.maximumWarningMaxRingTimeSound) {
            return getSoundObject(warningSoundList.value, widgetRef.value.WidgetLayout.maximumWarningMaxRingTimeSound)?.Rec_Path || ''
        }
        return ''
    })

    const maximumLimitMaxRingTimeSound = computed(() => {
        if (widgetRef.value?.WidgetLayout?.maximumLimitMaxRingTimeSound) {
            return getSoundObject(errorSoundList.value, widgetRef.value.WidgetLayout.maximumLimitMaxRingTimeSound)?.Rec_Path || ''
        }
        return ''

    })

    const backQueueSLASound = computed(() => {
        if (widgetRef.value?.WidgetLayout?.backQueueSLASound) {
            return getSoundObject(allSoundList.value, widgetRef.value.WidgetLayout.backQueueSLASound)?.Rec_Path || ''
        }
        return ''
    })

    const getSound = (type: string, isWaitTime: boolean) => {
        if(type === limitThresholdValue) {
            return isWaitTime ? maximumLimitMaxRingTimeSound.value : maximumLimitCallersSound.value
        }
        if (type === warningThresholdValue) {
            return isWaitTime ? maximumWarningMaxRingTimeSound.value: maximumWarningCallersSound.value
        }

        if (type === 'idle') {
            return backQueueSLASound.value
        }
        return ''

    }

    const setupNotification = ({
        thresholdValue,
        currentValue,
        entityName,
        property,
        type,
        timerStartValue,
        id,
        soundPlayed,
        notificationTag

    }: NotificationSetupParams) => {
        const notificationData = {
            notification_value: thresholdValue,
            entity_name: entityName,
            current_value: currentValue,
            property: property,
        }

        const soundItem: ISoundItem = {
            id: id,
            sound: getSound(type, !!timerStartValue),
            played: soundPlayed,
            isPlaying: false,
            timestamp: new Date().getTime(),
            notificationHTML: i18n.global.t(notificationTag, { ...notificationData })
        }

        if (timerStartValue) {
            soundItem.timerStartValue = timerStartValue
        }
        if (soundItem.sound) {
            setupSoundQueue(soundItem)
        }

    }

    return {
        maximumLimitCallersSound,
        maximumWarningCallersSound,
        maximumWarningMaxRingTimeSound,
        backQueueSLASound,
        maximumLimitMaxRingTimeSound,
        maximumLimitCallersValueFromSettings,
        maximumLimitWaitTimeValueFromSettings,
        maximumWarningCallersValueFromSettings,
        maximumWarningWaitTimeValueFromSettings,
        setupNotification,
    }

}
